import axios from "axios";
import { decryptFromStoreLoc } from "../helper";

export const apiClient = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  timeout: 120000,
});

apiClient.interceptors.request.use(
  function (config) {
    const data = decryptFromStoreLoc("token");

    const token = data?.token;
    config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

// AUTHENTICATION

export const adminLogin = (data) => {
  return apiClient.post("/auth/admin/login", data);
};
export const adminLogout = () => {
  return apiClient.post("/auth/user/logout");
};





